// Calendly type comes from src/types/calendly.d.ts

const SCRIPT_SRC = 'https://assets.calendly.com/assets/external/widget.js';
const CSS_HREF = 'https://assets.calendly.com/assets/external/widget.css';

let loadPromise: Promise<void> | null = null;

const ensureCalendly = (): Promise<void> => {
  if (typeof window === 'undefined') return Promise.resolve();
  if (window.Calendly) return Promise.resolve();
  if (loadPromise) return loadPromise;

  loadPromise = new Promise<void>((resolve, reject) => {
    if (!document.querySelector(`link[href="${CSS_HREF}"]`)) {
      const link = document.createElement('link');
      link.rel = 'stylesheet';
      link.href = CSS_HREF;
      document.head.appendChild(link);
    }

    const existing = document.querySelector<HTMLScriptElement>(`script[src="${SCRIPT_SRC}"]`);
    if (existing && window.Calendly) {
      resolve();
      return;
    }

    const script = existing || document.createElement('script');
    if (!existing) {
      script.src = SCRIPT_SRC;
      script.async = true;
      document.head.appendChild(script);
    }
    script.addEventListener('load', () => resolve(), { once: true });
    script.addEventListener('error', () => {
      loadPromise = null;
      reject(new Error('Failed to load Calendly'));
    }, { once: true });
  });

  return loadPromise;
};

export const openCalendly = async (calendlyUrl: string = 'https://calendly.com/hello-datryx/30min'): Promise<void> => {
  try {
    await ensureCalendly();
    window.Calendly?.initPopupWidget({ url: calendlyUrl });
  } catch (err) {
    console.error('Calendly failed to load', err);
    window.open(calendlyUrl, '_blank', 'noopener,noreferrer');
  }
};

export const prefetchCalendly = (): void => {
  ensureCalendly().catch(() => {
    /* swallow — open() will retry */
  });
};
